<template>
<div id="newsletters">
  <h2>Newsletters</h2>

  <newsletter-nav></newsletter-nav>

  <pagination
    ref="pagination"
    :resourceUrl="resourceUrl"
    orderBy="send_at"
    orderType="DESC"
    :pageSize="$root.defaultPageSize"
  >
    <template
      slot="pagination_hdr"
    >
    </template>
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'newsletter', params: { newsletterId: item.id }}"
      >
        {{ item.subject }}
        <span
          class="badge badge-primary"
        >
          {{ formattedDate(item.send_at) }}
        </span>
        <span
          class="badge badge-secondary"
          v-if="item.digest"
        >
          Digest
        </span>
      </router-link>
    </template>
    <template
      slot="pagination_footer"
    >
    </template>
  </pagination>
</div>
</template>

<script>
import NewsletterNav from '@/components/NewsletterNav'

import Pagination from 'sai-vue-kaminari'

export default {
  components: {
    'newsletter-nav': NewsletterNav,
    pagination: Pagination
  },

  computed: {
    resourceUrl () {
      let url = (this.newsletterTypeId ? ('/newsletter_types/' + this.newsletterTypeId) : '') + '/newsletters'
      return this.apiUrl(url, true)
    }
  },

  props: {
    newsletterTypeId: {
      type: String,
      default: undefined
    }
  },

  methods: {
    formattedDate (d) {
      return this.$root.displayDateFmt(d)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Newsletters.vue